import { useState } from "react";
import { useAvatarSource } from "./avatar-provider.js";
import { cn } from "@/lib/utils";

export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  return parts
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}

/** Photo when available; plain initials while it loads or when it is unavailable. */
export function FrAvatar(props: {
  name: string;
  src?: string | null;
  size?: number;
  className?: string;
  bordered?: boolean;
  participantId?: string | null | undefined;
  accountId?: string | null | undefined;
  self?: boolean | undefined;
}): React.JSX.Element {
  const size = props.size ?? 48;
  const identitySrc = useAvatarSource(props);
  const src = identitySrc ?? props.src;
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const [loadedSrc, setLoadedSrc] = useState<string | null>(null);
  const showPhoto = Boolean(src) && failedSrc !== src;
  return (
    <span
      className={cn(
        "relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full",
        "bg-[#18392d] font-sans font-medium text-[#dcc48c]",
        props.bordered === false ? "" : "border border-[rgba(201,169,97,0.55)]",
        props.className,
      )}
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.375),
      }}
      aria-hidden={showPhoto ? undefined : true}
    >
      {initialsOf(props.name)}
      {showPhoto ? (
        <img
          src={src ?? undefined}
          alt={props.name}
          className="absolute inset-0 h-full w-full object-cover"
          style={{ opacity: loadedSrc === src ? 1 : 0 }}
          onLoad={() => setLoadedSrc(src ?? null)}
          onError={() => setFailedSrc(src ?? null)}
        />
      ) : null}
    </span>
  );
}
